// Import React and Hooks
import React from 'react'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux'
// Import Actions
import { closeModalAction } from '../../actions/modalAction'
// Import Components
import BeerMask from './BeerMask'
import Button from './Button'
import FloatImg from './FloatImg'
import ShareButton from './ShareButton'
import DownloadButton from './DownloadButton'

import { toConoceMas } from '../../actions/datalayer'

// Modal Success Prop
interface modalSuccessProp {
  additionalClass?:string,
  dataModalSuccess: {
    id:string,
    isVisible:boolean,
    hasClose:boolean,
    title:string,
    text:string,
    photo:string,
    btn: {
      text:string,
      link:string
    } | null,
    shareBtn:boolean,
    downloadBtn:boolean
  }
}

const ModalSuccess = ( { additionalClass, dataModalSuccess }:modalSuccessProp ) => {



  // Use selector
  const currentId = useAppSelector( state => state.general.currentOffering.idOffering )



  // Destructuring
  const { title, text, btn, photo, shareBtn, downloadBtn } = dataModalSuccess



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  return (
    <section className={`modalSuccess ${ additionalClass ? additionalClass : ''}`}>
      <FloatImg
          additionalClass={`img1CutterImage`}
          alt="Arreglo floral"
          speed={ 0.013 }
          revert={ true }
          src={`${window.assetsURl}/imgs/shapes/cutterImageFlota.png`} />
      <FloatImg
          additionalClass={`img2CutterImage`}
          alt="Arreglo floral"
          speed={ 0.013 }
          revert={ true }
          src={`${window.assetsURl}/imgs/shapes/cutterImageFlota.png`} />
      <FloatImg
        additionalClass={'flowersModal1'}
        alt="Arreglo floral"
        speed={ 0.013 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-6.svg`} />
      <FloatImg
        additionalClass={'flowersModal2'}
        alt="Arreglo floral"
        speed={ 0.008 }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-7.svg`} />
      <FloatImg
        additionalClass={'petalModalS2 hiddenTablet'}
        alt="Pétalo de flor"
        speed={ 0.008 }
        src={`${window.assetsURl}/imgs/petals/petal-1.svg`} />
      <FloatImg
        additionalClass={'petalModalS3 hiddenTablet'}
        alt="Pétalo de flor"
        speed={ 0.008 }
        src={`${window.assetsURl}/imgs/petals/petal-3.svg`} />
      <FloatImg
        additionalClass={'butterflyModalS1 hiddenTablet'}
        alt="Mariposa"
        speed={ 0.008 }
        src={`${window.assetsURl}/imgs/shapes/butterfly-1.svg`} />
      <div className="modalSuccess__container">
        <div className="modalSuccess__box">
          { title && (
            <h2 className="modalSuccess__title mb30 mbM25">
             ¡TU OFRENDA VIVA FUE CREADA!
            </h2>
          ) }
          { text && (
            <p className="modalSuccess__text mb25">
              PUEDES COMPRAR TUS LATAS PERSONALIZADAS Y TE LAS ENVIAMOS A LA PUERTA DE TU CASA
            </p>
          ) }
          {/* btn && (
            <div className="w100 dF mb20">
                <a href="/tada-latas" target='_blank'><button
                  className={`btn btn--animated`} >
                  COMPRAR LATAS
                </button></a>
            </div>
          ) */}
          { btn && (
            <div className="w100 dF mb20">
              <Button
                url='/cempasuchil/ofrendas-vivas'
                text='CONTINUAR'
                functionClick={ (e) => {
                  toConoceMas();
                  dispatch( closeModalAction () )
                  setTimeout( () => window.location.reload(), 1 )
                } } />
            </div>
          ) }
        </div>
        <div className="modalSuccess__box">
          <BeerMask fileImg={ photo } />
        </div>
        <div className="modalSuccess__box">
          { text && (
            <p className="modalSuccess__text mb25">
              CON ESTA OFRENDA ESTÁS PARTICIPANDO EN EL SORTEO DE UN SIX DE LATAS PERSONALIZADAS.
            </p>
          ) }
          { downloadBtn && (
            <div className="w100 taC mb15 wMA mrM5 mlM5 mbM10">
              <DownloadButton
                text="Descargar Lata" />
            </div>
          ) }
          { shareBtn && currentId !== 0 && (
            <div className="w100 taC wMA mrM5 mlM5 mbM10">
              <ShareButton
                text="Compartir"
                id={ currentId } />
            </div>
          ) }
        </div>
      </div>
    </section>
  )
}



export default ModalSuccess
